export default {
  ArrowRepeat: 'arrow-repeat',
  ArrowsAngleContract: 'arrows-angle-contract',
  ArrowsAngleExpand: 'arrows-angle-expand',
  Calendar: 'calendar',
  CartFill: 'cart-fill',
  ChevronLeft: 'chevron-left',
  ChevronRight: 'chevron-right',
  Dash: 'dash',
  ExclamationCircleFill: 'exclamation-circle-fill',
  Keyboard: 'keyboard',
  Plus: 'plus',
  RecordCircle: 'record-circle',
  X: 'x',
  XCircleFill: 'x-circle-fill',
  BoxArrowUpRight: 'box-arrow-up-right',
};
